import { render } from "./PopupKycPhase2Info.vue?vue&type=template&id=6d7fbfec&scoped=true"
import script from "./PopupKycPhase2Info.vue?vue&type=script&lang=js"
export * from "./PopupKycPhase2Info.vue?vue&type=script&lang=js"

import "./PopupKycPhase2Info.vue?vue&type=style&index=0&id=6d7fbfec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7fbfec"]])

export default __exports__